export const TOOFI_CARD_VARIANT_CLASS = {
  shell:
    "rounded-[1.4rem] border border-[color:var(--athr-chrome-border)] bg-[linear-gradient(180deg,rgba(255,255,255,0.9),rgba(248,250,252,0.82))] shadow-[0_18px_40px_rgba(15,23,42,0.1)] backdrop-blur-2xl",
  artifact:
    "rounded-[1.15rem] border border-[color:var(--athr-border-soft)] bg-[linear-gradient(180deg,rgba(255,255,255,0.99),rgba(248,250,252,0.96))] shadow-[0_12px_28px_rgba(15,23,42,0.04)]",
  entry:
    "rounded-[1.35rem] border border-[color:var(--athr-border-soft)] bg-[linear-gradient(180deg,rgba(255,255,255,0.99),rgba(248,250,252,0.96))] shadow-[0_14px_32px_rgba(15,23,42,0.05)]",
  meta:
    "rounded-full border border-[color:var(--athr-border-soft)] bg-white/96 shadow-[0_8px_18px_rgba(15,23,42,0.04)]",
} as const;

export const TOOFI_LABEL_CLASS =
  "rounded-full border border-[color:var(--athr-border-soft)] bg-white/98 px-2.5 py-0.5 text-[9px] font-semibold tracking-[0.02em] text-slate-500";

export const TOOFI_ENTRY_TITLE_CLASS = "text-base font-semibold tracking-[-0.02em] text-slate-950 sm:text-lg";

export const TOOFI_ENTRY_COPY_CLASS = "text-sm leading-6 text-slate-600";

export const TOOFI_META_CHIP_CLASS =
  "inline-flex items-center gap-1 rounded-full border border-[color:var(--athr-border-soft)] bg-white/96 px-2.5 py-1 text-[10px] font-medium tracking-[0.01em] text-slate-500 shadow-[0_8px_18px_rgba(15,23,42,0.04)]";
